import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  .menu-items:focus-visible {\n    border: 1px solid #262638;\n  }\n  .address-btn {\n    background: transparent;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: white !important;\n  }\n\n  .user-address {\n    margin-left: 10px;\n    margin-right: 10px;\n  }\n\n  .App-header-user-address:hover {\n    background: #808aff14;\n  }\n\n  .menu-items {\n    position: absolute;\n    right: 0;\n    top: 43px;\n    min-width: 155px;\n    width: 100%;\n    transform-origin: top right;\n    border-radius: 4px;\n    background: #16182e;\n    border: 1px solid #32344c;\n    list-style: none;\n    cursor: pointer;\n    outline: none;\n    z-index: 1000;\n  }\n  .menu-item {\n    display: flex;\n    padding: 12px;\n    align-items: center;\n    gap: 8px;\n    align-self: stretch;\n    border-radius: 12px;\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 120%; /* 16.8px */\n    cursor: pointer;\n\n    p {\n      user-select: none;\n    }\n  }\n  .menu-item:hover {\n    background: #191b2e !important;\n    opacity: 1;\n    color: #eee;\n  }\n  .menu-item > p {\n    margin: 0px;\n    padding-left: 10px;\n  }\n  .menu-item > a {\n    display: inline-flex;\n  }\n\n  @media screen and (max-width: 370px) {\n    .user-address {\n      margin-left: 0;\n    }\n    .address-btn {\n      display: flex;\n      justify-content: space-between;\n    }\n    .user-avatar {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: ",
        "px;\n  transform: translate3d(0, 0, 0);\n  border-bottom: 1px solid ",
        ";\n  padding-left: 16px;\n  padding-right: 16px;\n\n  &.header-scroll {\n    background: ",
        ';\n    &:after {\n      height: 1.3rem;\n      width: 100%;\n      content: " ";\n      background: transparent linear-gradient(180deg, #00000030 0%, #00000000 100%) 0% 0% no-repeat padding-box;\n      position: absolute;\n      bottom: -1.3rem;\n      left: 0;\n    }\n  }\n'
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  /* top: ",
        "; */\n  top: 0;\n  left: 0;\n  transition: top 0.2s;\n  /* height: ",
        "; */\n  width: 100%;\n  z-index: 20;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  height: ",
        ";\n  min-height: ",
        ";\n  max-height: ",
        ";\n  width: 100%;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  display: flex;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  flex-grow: 1;\n  transition: margin-top 0.2s, margin-left 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  transform: translate3d(0, 0, 0);\n  max-width: 100%;\n  background-size: contain;\n  background-repeat: no-repeat;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  background: linear-gradient(180deg, #070c36, #010211);\n  width: 300px;\n  height: ",
        ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  z-index: 99;\n  backdrop-filter: blur(20px);\n  overflow-y: scroll;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CloseIcon, HamburgerIcon, OPXLogo } from "@pancakeswap/uikit";
import { AnimatePresence, motion } from "framer-motion";
import throttle from "lodash/throttle";
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import BottomNav from "../../components/BottomNav";
import { Box } from "../../components/Box";
import Flex from "../../components/Box/Flex";
import Footer from "../../components/Footer";
import MenuItems from "../../components/MenuItems/MenuItems";
import { useMatchBreakpoints } from "../../contexts";
import CakePrice from "../../components/CakePrice/CakePrice";
import Logo from "./components/Logo";
import { MENU_HEIGHT, TOP_BANNER_HEIGHT, TOP_BANNER_HEIGHT_MOBILE } from "./config";
import { MenuContext } from "./context";
var Wrapper = styled.div.withConfig({
    componentId: "sc-9694f290-0"
})(_templateObject());
var StyledNav = styled.nav.withConfig({
    componentId: "sc-9694f290-1"
})(_templateObject1(), MENU_HEIGHT, function(param) {
    var theme = param.theme;
    return theme.colors.white10;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundAlt;
});
var FixedContainer = styled.div.withConfig({
    componentId: "sc-9694f290-2"
})(_templateObject2(), function(param) {
    var showMenu = param.showMenu, height = param.height;
    return showMenu ? 0 : "-".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
});
var TopBannerContainer = styled.div.withConfig({
    componentId: "sc-9694f290-3"
})(_templateObject3(), function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
}, function(param) {
    var height = param.height;
    return "".concat(height, "px");
});
var BodyWrapper = styled(Box).withConfig({
    componentId: "sc-9694f290-4"
})(_templateObject4());
var Inner = styled.div.withConfig({
    componentId: "sc-9694f290-5"
})(_templateObject5());
var DrawerWrapper = styled(motion.div).withConfig({
    componentId: "sc-9694f290-6"
})(_templateObject6(), function() {
    return "".concat(window.innerHeight, "px");
});
var Menu = function(param) {
    var _linkComponent = param.linkComponent, linkComponent = _linkComponent === void 0 ? "a" : _linkComponent, banner = param.banner, rightSide = param.rightSide, isDark = param.isDark, toggleTheme = param.toggleTheme, currentLang = param.currentLang, setLang = param.setLang, cakePriceUsd = param.cakePriceUsd, links = param.links, subLinks = param.subLinks, footerLinks = param.footerLinks, activeItem = param.activeItem, activeSubItem = param.activeSubItem, langs = param.langs, buyCakeLabel = param.buyCakeLabel, children = param.children;
    var ref = useMatchBreakpoints(), isMobile = ref.isMobile, isMd = ref.isMd, isDesktop = ref.isDesktop;
    var ref1 = useState(false), addBg = ref1[0], setAddBg = ref1[1];
    var ref2 = useState(true), showMenu = ref2[0], setShowMenu = ref2[1];
    var ref3 = useState(false), isDrawerShow = ref3[0], setIsDrawerShow = ref3[1];
    var refPrevOffset = useRef("object" === "undefined" ? 0 : window.pageYOffset);
    var topBannerHeight = isMobile ? TOP_BANNER_HEIGHT_MOBILE : TOP_BANNER_HEIGHT;
    var totalTopMenuHeight = banner ? MENU_HEIGHT + topBannerHeight : MENU_HEIGHT;
    useEffect(function() {
        window.addEventListener("scroll", function() {
            setAddBg(window.scrollY > 5);
        });
        if (window.pageYOffset > 5) {
            setAddBg(true);
        }
    }, []);
    useEffect(function() {
        var handleScroll = function() {
            var currentOffset = window.pageYOffset;
            var isBottomOfPage = window.document.body.clientHeight === currentOffset + window.innerHeight;
            var isTopOfPage = currentOffset === 0;
            // Always show the menu when user reach the top
            if (isTopOfPage) {
                setShowMenu(true);
            } else if (!isBottomOfPage) {
                if (currentOffset < refPrevOffset.current || currentOffset <= totalTopMenuHeight) {
                    // Has scroll up
                    setShowMenu(true);
                } else {
                    // Has scroll down
                    setShowMenu(false);
                }
            }
            refPrevOffset.current = currentOffset;
        };
        var throttledHandleScroll = throttle(handleScroll, 200);
        window.addEventListener("scroll", throttledHandleScroll);
        return function() {
            window.removeEventListener("scroll", throttledHandleScroll);
        };
    }, [
        totalTopMenuHeight
    ]);
    // Find the home link if provided
    var homeLink = links.find(function(link) {
        return link.label === "Home";
    });
    var subLinksWithoutMobile = subLinks === null || subLinks === void 0 ? void 0 : subLinks.filter(function(subLink) {
        return !subLink.isMobileOnly;
    });
    var subLinksMobileOnly = subLinks === null || subLinks === void 0 ? void 0 : subLinks.filter(function(subLink) {
        return subLink.isMobileOnly;
    });
    useEffect(function() {
        var handleClick = function(e) {
            var ref, ref1;
            if (!((ref = document.querySelector(".drawer-wrapper")) === null || ref === void 0 ? void 0 : ref.contains(e.target)) && !((ref1 = document.querySelector(".hamburger-menu")) === null || ref1 === void 0 ? void 0 : ref1.contains(e.target))) {
                setIsDrawerShow(false);
            }
        };
        window.addEventListener("click", handleClick);
        return function() {
            return window.removeEventListener("click", handleClick);
        };
    }, []);
    return /*#__PURE__*/ _jsx(MenuContext.Provider, {
        value: {
            linkComponent: linkComponent
        },
        children: /*#__PURE__*/ _jsxs(Wrapper, {
            children: [
                /*#__PURE__*/ _jsx(FixedContainer, {
                    showMenu: showMenu,
                    height: totalTopMenuHeight,
                    children: /*#__PURE__*/ _jsxs(StyledNav, {
                        className: "".concat(addBg ? "header-scroll" : ""),
                        children: [
                            /*#__PURE__*/ _jsx(AnimatePresence, {
                                children: isDrawerShow && /*#__PURE__*/ _jsxs(DrawerWrapper, {
                                    initial: {
                                        x: "-100%"
                                    },
                                    animate: {
                                        x: "0%"
                                    },
                                    exit: {
                                        x: "-100%"
                                    },
                                    transition: {
                                        duration: 0.2
                                    },
                                    className: "drawer-wrapper",
                                    children: [
                                        /*#__PURE__*/ _jsxs(Flex, {
                                            height: "62px",
                                            justifyContent: "space-between",
                                            children: [
                                                /*#__PURE__*/ _jsx(OPXLogo, {
                                                    height: "40px",
                                                    ml: "16px"
                                                }),
                                                /*#__PURE__*/ _jsx(CloseIcon, {
                                                    mr: "16px",
                                                    width: "20px",
                                                    color: "white",
                                                    onClick: function() {
                                                        return setIsDrawerShow(!isDrawerShow);
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Box, {
                                            children: /*#__PURE__*/ _jsx(MenuItems, {
                                                isDrawer: true,
                                                items: links,
                                                activeItem: activeItem,
                                                activeSubItem: activeSubItem
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsxs(Flex, {
                                children: [
                                    !isDesktop && /*#__PURE__*/ _jsx(Flex, {
                                        mr: "10px",
                                        onClick: function() {
                                            return setIsDrawerShow(!isDrawerShow);
                                        },
                                        className: "hamburger-menu",
                                        children: /*#__PURE__*/ _jsx(HamburgerIcon, {})
                                    }),
                                    /*#__PURE__*/ _jsx(Logo, {
                                        isDark: isDark,
                                        href: "https://mummy.finance"
                                    }),
                                    isDesktop && /*#__PURE__*/ _jsx(MenuItems, {
                                        items: links,
                                        activeItem: activeItem,
                                        activeSubItem: activeSubItem,
                                        ml: "24px"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Flex, {
                                alignItems: "center",
                                height: "100%",
                                children: [
                                    isDesktop && !isMd && /*#__PURE__*/ _jsx(Box, {
                                        children: /*#__PURE__*/ _jsx(CakePrice, {
                                            showSkeleton: false,
                                            cakePriceUsd: cakePriceUsd
                                        })
                                    }),
                                    rightSide
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(BodyWrapper, {
                    mt: !subLinks ? "".concat(totalTopMenuHeight + 1, "px") : "0",
                    children: /*#__PURE__*/ _jsxs(Inner, {
                        isPushed: false,
                        showMenu: showMenu,
                        children: [
                            children,
                            /*#__PURE__*/ _jsx(Footer, {})
                        ]
                    })
                }),
                isMobile && /*#__PURE__*/ _jsx(BottomNav, {
                    items: links,
                    activeItem: activeItem,
                    activeSubItem: activeSubItem
                })
            ]
        })
    });
};
export default Menu;
